import React from 'react';

/**
 * GooglePlayIcon
 *
 * The official 4-colour Google Play prism (blue top, green left,
 * red bottom, yellow "flag" on the right) rendered as a single inline
 * SVG that tapers to a SHARP single-point apex on the right — the way
 * the real Google Play mark is drawn.
 *
 * Used in:
 *   - HomeAlt2 hero CTA + footer download CTA
 *   - DownloadApp page "Get it on Google Play" button
 *
 * Pass any standard SVG props (className, width, height, aria-label).
 */
const GooglePlayIcon = (props) => (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    {/* Vertices — the outer silhouette is a triangle that points right.
       A  = (100, 40)   top-left hinge
       B  = (100, 472)  bottom-left hinge
       R  = (440, 256)  SHARP right apex (all four facets converge here)
       M  = (240, 256)  inner center (back-hinge meeting point)
       T1 = (355, 202)  top-of-kite point (lies on the AR edge)
       T2 = (355, 310)  bottom-of-kite point (lies on the BR edge)

       Each facet shares edges with its neighbours so the four colours
       meet cleanly with no anti-alias seams. */}

    {/* Green — left/back facet (the vertical hinge plate). */}
    <path fill="#34A853" d="M100 40 L240 256 L100 472 Z" />
    {/* Blue — top facet (hinge top → top-of-kite → centre). */}
    <path fill="#4285F4" d="M100 40 L355 202 L240 256 Z" />
    {/* Red — bottom facet (hinge bottom → centre → bottom-of-kite). */}
    <path fill="#EA4335" d="M100 472 L240 256 L355 310 Z" />
    {/* Yellow — right "flag" kite tapering to the sharp apex. */}
    <path fill="#FBBC04" d="M355 202 L440 256 L355 310 L240 256 Z" />
  </svg>
);

export default GooglePlayIcon;
